import { render } from "./CompNovaTag.vue?vue&type=template&id=42b5673d&scoped=true"
import script from "./CompNovaTag.vue?vue&type=script&lang=js"
export * from "./CompNovaTag.vue?vue&type=script&lang=js"

import "./CompNovaTag.vue?vue&type=style&index=0&id=42b5673d&scoped=true&lang=css"
import "./CompNovaTag.vue?vue&type=style&index=1&id=42b5673d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b5673d"]])

export default __exports__